/**
 * Capitalizes the first letter of the given string.
 * @param {string} str The string to capitalize
 * @return {string} The capitalized string
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 * capitalize(`foo`); // => Foo
 * capitalize(`FOO`); // => FOO
 * capitalize(`fOO`); // => FOO
 */
const capitalize = (str) => `${str[0].toUpperCase()}${str.slice(1)}`;

/** @component */
export default capitalize;
